import React, { useState } from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { StepperField } from './StepperField';

const meta = {
  title: 'Diary/StepperField',
  component: StepperField,
  args: {
    label: 'Nighttime awakenings',
    value: 2,
    min: 0,
    max: 20,
    onChange: () => undefined,
  },
  decorators: [
    Story => (
      <View style={{ width: 220, flexDirection: 'row' }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof StepperField>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};

const InteractiveStepperField = (args: React.ComponentProps<typeof StepperField>) => {
  const [value, setValue] = useState(args.value);
  return (
    <View style={{ width: 220, flexDirection: 'row' }}>
      <StepperField {...args} value={value} onChange={setValue} />
    </View>
  );
};

export const Interactive: Story = {
  render: args => <InteractiveStepperField {...args} />,
};
